import { ActionReducer, UPDATE } from "@ngrx/store";
import { isArray, isEmpty } from "lodash-es";

import { SYNC_SUFFIX } from "../fetch-status/fetch-status.const";
import { ActionWithPayload } from "../model";

const ACTION_PREFIX = "[State Transfer Actions]";
export const STATE_TRANSFER_ACTION_TYPE = {
	set: `${ACTION_PREFIX} Set ${SYNC_SUFFIX}`,
};

let transferedState: any | undefined;

/**
 * Meta reducer for transfering state from server to browser
 *
 * ```ts
 *StoreModule.forRoot({}, {
 *   metaReducers: [stateTransfer]
 *})
 * ```
 */
export function stateTransfer(reducer: ActionReducer<any>): ActionReducer<any> {
	return (state: any, action: ActionWithPayload) => {
		if (action.type === STATE_TRANSFER_ACTION_TYPE.set) {
			transferedState = action.payload;
			return { ...state, ...action.payload };
		}

		/*
			ngrx will clear all initial (transfered) state parts for not yet loaded feature modules
			here we set transfered state parts for feature modules when they are loaded, on "update-reducers" action

			more info: https://github.com/ngrx/platform/issues/1846
		 */
		const features: string[] = (action as any).features;
		if (action.type === UPDATE && !isEmpty(features) && isArray(features) && transferedState) {
			const newState = { ...state };

			// for every new reducer set transfered state
			for (const feature of features) {
				newState[feature] = newState[feature] || transferedState[feature];
			}

			return reducer(newState, action);
		}

		return reducer(state, action);
	};
}
